"use client";

import type { RadioVariantProps } from "@daangn/carotene";
import { unstable_radioGroupStyle } from "@daangn/carotene";
import clsx from "clsx";
import * as React from "react";

import { RadioAnchorContext } from "./context";

export interface RadioAnchorGroupProps
  extends React.HTMLAttributes<HTMLElement>,
    RadioVariantProps {
  defaultValue: string | undefined;
  label?: string;
}

export const RadioAnchorGroup = React.forwardRef<
  HTMLInputElement,
  RadioAnchorGroupProps
>(({ className, size, label, children, defaultValue, ...props }, ref) => {
  const classNames = unstable_radioGroupStyle();
  return (
    <div ref={ref} className={clsx(classNames.root, className)} {...props}>
      {label && <span className={classNames.label}>{label}</span>}
      <div>
        <RadioAnchorContext.Provider value={{ size, defaultValue }}>
          {children}
        </RadioAnchorContext.Provider>
      </div>
    </div>
  );
});
RadioAnchorGroup.displayName = "RadioAnchorGroup";
